import { FC } from "react";
import { IconProps } from "./types";

export const MinusThick: FC<IconProps> = ({
  fill = "#111",
  width = 24,
  height = 24,
  className,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width={width}
    height={height}
    className={className}
    {...props}
  >
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M2 12a2 2 0 0 1 2-2h16a2 2 0 1 1 0 4H4a2 2 0 0 1-2-2z"
      fill={fill}
    />
  </svg>
);
